<template>
    <div class="survey-root-node-container">
        <div class="survey-root-node-container__field"
             v-for="(child, index) in field.children"
             v-bind:key="index" v-bind:field="child">
                <survey-field v-bind:field="child"
                              @nodeChange="onNodeChange"></survey-field>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SurveyRootNode',
  props: ['field'],
  methods: {
    onNodeChange() {
      this.$emit('nodeChange', this.field);
    },
  },
};
</script>

<style src="./SurveyRootNode.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyRootNode/SurveyRootNode.vue